// Dependencies
import PropTypes from 'prop-types';


export const userLocationShape = PropTypes.shape({
  postalcode: PropTypes.string,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  referer: PropTypes.string // misspelled in rWAVES API
});

export const organizationShape = PropTypes.shape({
  id: PropTypes.string,
  isDeleted: PropTypes.bool,
  logoSrc: PropTypes.string,
  Name: PropTypes.string,
  Description: PropTypes.string,
  LogoFilename: PropTypes.string,
  FaviconFilename: PropTypes.string,
  Domain: PropTypes.string,
  clusteringEnabled: PropTypes.bool,
  SubscriptionType: PropTypes.string,
  SubscriptionTypeDisplay: PropTypes.string,
  cssFileName: PropTypes.string
});

export const profileDataShape = PropTypes.shape({
  active: PropTypes.bool,
  appUserId: PropTypes.string,
  email: PropTypes.string,
  emailConfirmed: PropTypes.bool,
  firstName: PropTypes.string,
  id: PropTypes.string,
  lastLogin: PropTypes.string,
  lastName: PropTypes.string,
  organization: organizationShape,
  organizationId: PropTypes.string,
  organizationUser: PropTypes.object,
  permissionsHQ: PropTypes.number,
  permissionsOperation: PropTypes.number,
  permissionsRegion: PropTypes.number,
  permissionsSite: PropTypes.number,
  phoneNumber: PropTypes.string,
  // ....primary... attributes with null values
  primaryOrganization: PropTypes.string,
  primaryOrganizationType: PropTypes.string,
  primaryReferer: PropTypes.string,
  primaryTitle: PropTypes.string,
  primaryZip: PropTypes.string,
  primaryZipLatitude: PropTypes.string,
  primaryZipLongitude: PropTypes.string,
  title: PropTypes.string,
  userName: PropTypes.string,
  zoneId: PropTypes.string
});

export const profileShape = PropTypes.shape({
  data: profileDataShape,
  zone: PropTypes.object, // This is defined on home module
  account: PropTypes.string
});
